export default function bestRouteMatch (params, searchRoutes, minScore = null) {
  let bestRoute;
  for (let {routePattern, paramKeys, singleValueParams} of searchRoutes) {
    let routeCandidate = {
      routePattern,
      singleValueParams,
      matchScore: 0,
    };

    for (let paramName of paramKeys) {
      if (paramName in params) {
        // matching more params is strictly better
        routeCandidate.matchScore += 1.0000;
        if (paramName in singleValueParams) {
          if (singleValueParams[paramName] === params[paramName]) {
            // matching params by value is better, but not as important as
            // matching more of them
            routeCandidate.matchScore += 0.0100;
          } else {
            // however, if its the same param as the static
            // ones, but with the wrong value, it is NOT
            // preferred!
            routeCandidate.matchScore -= 0.0100;
          }
        }
      } else {
        // ALL ELSE being equal, we prefer not having extra params tacked on
        routeCandidate.matchScore -= 0.0001;
      }

    }

    if (!bestRoute || routeCandidate.matchScore > bestRoute.matchScore) {
      bestRoute = routeCandidate;
    }
  }
  if (minScore === null || bestRoute.matchScore >= minScore) {
    return bestRoute;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-router/bestRouteMatch.js